// src/app/app.routes.ts
import { Routes, CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { RolesService } from '../app/services/roles.service';
import { RoleGuard } from './guards/role.guard';

export const adminOnly: CanMatchFn = () => {
  const roles = inject(RolesService);
  const router = inject(Router);
  return roles.hasRole('AdmUPS') ? true : router.createUrlTree(['/issues']);
};

export const routes: Routes = [
  { path: '', redirectTo: '/issues', pathMatch: 'full' },

  {
    path: 'issues',
    loadComponent: () =>
      import('./components/pages/issues/issues.component').then(m => m.IssuesComponent)
  },
  {
    path: 'sprint-planning',
    loadComponent: () =>
      import('./components/pages/sprint-planning/sprint-planning.component')
        .then(m => m.SprintPlanningComponent)
  },
  {
    path: 'dashboards',
    loadComponent: () =>
      import('./components/pages/dashboards/dashboards.component')
        .then(m => m.DashboardsComponent)
  },
  {
    path: 'admin',
    canActivate: [RoleGuard],
    // canMatch: [adminOnly],
    data: { requiredRole: 'AdmUPS' },
    loadComponent: () =>
      import('./components/pages/admin/admin.component').then(m => m.AdminComponent)
  },
  {
    path: 'table-management',
    canActivate: [RoleGuard],
    data: { requiredRole: 'AdmUPS' },
    loadComponent: () =>
      import('./components/pages/table-management/table-management.component')
        .then(m => m.TableManagementComponent)
  },
  {
    path: 'dhe',
    loadComponent: () =>
      import('./components/pages/dhe/dhe-main/dhe-main.component')
        .then(m => m.DheMainComponent)
  },
  {
    path: 'dhe-equipes',
    loadComponent: () =>
      import('./components/pages/dhe/equipes/equipes.component')
        .then(m => m.EquipesComponent)
  },
  {
    path: 'dhe-equipes/:id/cadastros',
    loadComponent: () =>
      import('./components/pages/dhe/equipes/cadastros-equipe/cadastros-equipe.component')
        .then(m => m.CadastrosEquipeComponent)
  },

  { path: '**', redirectTo: '/issues' }
];
